// src/config/tenant.ts
export function getClientId(): string {
  // First, check for the runtime injected value (production via Node.js server)
  const metaTag = document.querySelector('meta[name="vireon-client-id"]');
  if (metaTag) {
    const content = metaTag.getAttribute('content');
    // If it's not the placeholder, use it
    if (content && content !== '__CLIENT_ID__') {
      return content;
    }
  }

  // Fallback for local Vite development where the Node server isn't running
  return import.meta.env.VITE_CLIENT_ID || 'omega';
}
